import { customAlphabet } from 'nanoid';

export const randomUtil = {
  alphaNumericLowercase: (length: number) => {
    return customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', length)();
  },
};
